<script>
export default {
  name: "or-break",
  props: {
    displayText: String,
  },
};
</script>
<template>
  <v-row justify="center" class="mx-0">
    <v-col col style="text-align:center;padding-left:0px;padding-right:0px;">
      <div style="position:relative;overflow: hidden !important;text-align: center !important;">
        <span class="or-text">{{ displayText ? displayText : "or" }}</span>
      </div>
    </v-col>
  </v-row>
</template>
<style scoped>
.or-text {
  position: relative;
  padding: 16px;
}
.or-text::before {
  content: "" !important;
  position: absolute !important;
  border-bottom: 1px solid rgb(228, 228, 228) !important;
  top: 50% !important;
  right: 100% !important;
  width: 5000px !important;
}
.or-text::after {
  content: "" !important;
  position: absolute !important;
  border-bottom: 1px solid rgb(228, 228, 228) !important;
  top: 50% !important;
  left: 100% !important;
  width: 5000px !important;
}
</style>
